import { RootState } from "../../rootReducer";

export const selectIsLoading = (state: RootState) =>
  state.attendanceStatus.loading;
export const attendanceStatusErrorMessage = (state: RootState) =>
  state.attendanceStatus.error;
export const attendanceStatusDataResponse = (state: RootState) =>
  state.attendanceStatus.attendanceStatusResponse;
